var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 2.5C4.95266 2.5 3.83337 3.61929 3.83337 5V11.6667C3.83337 12.1269 4.20647 12.5 4.66671 12.5C5.12694 12.5 5.50004 12.1269 5.50004 11.6667V5C5.50004 4.53976 5.87314 4.16667 6.33337 4.16667H11.3334C11.7936 4.16667 12.1667 3.79357 12.1667 3.33333C12.1667 2.8731 11.7936 2.5 11.3334 2.5H6.33337Z",
    fill: "#9965F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83337 5.83333C7.9129 5.83333 7.16671 6.57952 7.16671 7.5V15.8333C7.16671 16.7538 7.9129 17.5 8.83337 17.5H14.6667C15.5872 17.5 16.3334 16.7538 16.3334 15.8333V7.5C16.3334 6.57953 15.5872 5.83333 14.6667 5.83333H8.83337ZM8.83337 7.5H14.6667V15.8333H8.83337V7.5Z",
    fill: "#9965F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b8dc7efe21acf684adfbc3f83ac62100.svg";
export { ForwardRef as ReactComponent };